module.exports = __webpack_public_path__ + "img/part3-3.d88f9074.png";